import {
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Paper,
  MenuItem,
  Divider,
  Grid,
  Button,
  DialogActions,
  TextField,
} from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { WSIcons } from "../../../commonFunctions/iIcons";

interface ClearKOTProps {
  open: boolean;
  onClose: () => void;
}

export const ClearKOT: React.FC<ClearKOTProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ backgroundColor: "#388e3c", color: "#fff" }}>
        Clear Hold KOT/Receipt
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#fff",
          }}
        >
          <WSIcons.CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Grid
          sx={{
            height: "30rem",
            backgroundColor: "#e0e0e0",
            border: "1px solid #ccc",
            display: "flex",
            mt:2
          }}
        ></Grid>
      </DialogContent>

      <Grid
        item
        mt={2}
        sx={{
          backgroundColor: "#333",
          padding: 2,
        }}
      >
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <WSIcons.GTranslateIcon fontSize="medium" sx={{ color: "#fff" }} />
          </Grid>

          <Grid item>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button variant="contained" color="success">
                Clear
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};
